import { message } from 'antd';
import { mapSnakeCaseToSpaceCase } from './mapper';
export const displayError = (error: any): void => {
  const errorData = error?.data?.error;
  if (errorData) {
    if (typeof errorData === 'string') {
      message.error(errorData);
    } else {
      const { details, message: errorMessage, statusCode } = errorData;

      if (details && typeof details === 'object' && details !== null) {
        Object.keys(details).forEach((key) => {
          if (
            typeof details[key] === 'object' &&
            !Array.isArray(details[key])
          ) {
            Object.keys(details[key]).forEach((subKey) => {
              message.error(
                `${mapSnakeCaseToSpaceCase(key)}.${mapSnakeCaseToSpaceCase(subKey)} - ${details[key][subKey].join(', ')}`,
              );
            });
          } else {
            message.error(
              `${mapSnakeCaseToSpaceCase(key)} - ${details[key].join(', ')}`,
            );
          }
        });
      } else if (errorMessage) {
        message.error(errorMessage);
      } else {
        message.error('An unexpected error occurred');
      }
    }
  } else {
    message.error('An error occurred with no additional information provided.');
  }
};

export const displaySuccess = (successMsg: any = 'Successfull'): void => {
  message.success(successMsg);
};

export const displayWarning = (warningMsg: any = 'Warning'): void => {
  message.warning(warningMsg);
};
export const displayInfo = (infoMsg: any = 'Info'): void => {
  message.info(infoMsg);
};
export const displayErrorText = (errorMsg: any = 'Error'): void => {
  message.error(errorMsg);
};
